import React from 'react'
import SigninTemplate from '../../templates/Signin/SigninTemplate'

const Signin = () => {
  return (
    <SigninTemplate />
  )
}

export default Signin